export default class ApiResourceManager {
  client;

  constructor(client) {
    this.client = client;
  }

  request = (config) => this.client.request(config);
}
